import { render } from "./arrangeQuestion.vue?vue&type=template&id=17b54bb3&scoped=true"
import script from "./arrangeQuestion.vue?vue&type=script&lang=js"
export * from "./arrangeQuestion.vue?vue&type=script&lang=js"

import "./arrangeQuestion.vue?vue&type=style&index=0&id=17b54bb3&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b54bb3"]])

export default __exports__